import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareViewNotFoundRoute: InvariantJiraRoute = {
	name: 'software-view-not-found',
	exact: true,
	path: '/jira/software/projects/:projectKey/not-found',
};
